import React, { useEffect, useState } from "react";
import DetailedMoods from "../detailedView/DetailedMoods";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import useHandlePlayerArrays from "../hooks/useHandlePlayerArrays";
import LiveRating from "../misc/elements/LiveRating";
import activeStore from "../stores/activeStore";
import Header from "./Header";
import TimePassed from "./TimePassed";
import activeNumbers from "./activeNumbers";
import NumberBar from "./NumberBar";
import ActiveButtons from "./ActiveButtons";

const ActiveBoxDisplay = ({
  box,
  handleActiveBox,
  boxType,
  setShowActiveBox,
}) => {
  const [totalTime, setTotalTime] = useState({ seconds: 0, minutes: 0 });
  const [displayedNumbers, setDisplayedNumbers] = useState([]);

  const [openObject, setOpenObject] = useState(null);
  const [savedObject, setSavedObject] = useState(null);
  const { findObjectById } = useHandlePlayerArrays();
  function onGoalCompleted() {}

  useEffect(() => {
    if (openObject && savedObject) {
      const n = activeNumbers(savedObject, openObject);
      setDisplayedNumbers(n);
    }
  }, [openObject, savedObject]);

  useEffect(() => {
    function onObjectFound(objects) {
      setTotalTime({ seconds: 0, minutes: objects.open.minutes.active });
      setOpenObject(objects.open);
      setSavedObject(objects.saved);
    }
    if (box) findObjectById(box.id, box.type, onObjectFound);
  }, []);
  return (
    <div className="divColumn" style={{ width: "100%", height: "100%" }}>
      <div className="divRow" style={{ marginBottom: "5px" }}>
        <img src={box.image} style={{ width: "50%" }} />
        <TimePassed
          width="100%"
          timePassed={handleActiveBox.timePassed}
          totalPassed={totalTime}
        />
      </div>
      <Header shortDescription={box.shortDescription} />
      <div style={{ marginTop: "5px" }}>
        <LiveRating
          rated={box.ratings.first}
          icon={boxType?.ratings.active.first.icon}
          description={boxType?.ratings.active.first.hint}
          field={"first"}
          onTick={handleActiveBox.onRatingTick}
          tickTiming={1.5}
        />
        <div style={{ marginTop: "5px" }}>
          <LiveRating
            rated={box.ratings.second}
            icon={boxType?.ratings.active.second.icon}
            description={boxType?.ratings.active.second.hint}
            field={"second"}
            onTick={handleActiveBox.onRatingTick}
            tickTiming={2}
          />
        </div>
        <div style={{ marginTop: "5px" }}>
          <DetailedMoods
            moodObject={box.moods}
            imgSize="24px"
            isSeconds={true}
          />
        </div>
        <div style={{ marginTop: "5px" }}>
          <NumberBar numbers={displayedNumbers} />
        </div>
      </div>
      <ActiveButtons
        setShowActiveGoal={setShowActiveBox}
        box={box}
        stopActive={handleActiveBox.stopActive}
        onCompleted={handleActiveBox.onBoxCompleted}
        moods={false}
        width="100%"
      />
    </div>
  );
};

export default ActiveBoxDisplay;
